import { AppBar, Drawer as MuiDrawer, Toolbar } from "@material-ui/core";
import classnames from "classnames";
import * as React from "react";

import { PageActionButton, Text } from "../";
import { TimesIcon } from "../../assets/icons";
import { useStyles } from "./drawer.styles";

interface Props {
    id?: string;
    children?: React.ReactNode;
    header: string | React.ReactNode;
    isOpen?: boolean;
    onClose?: () => void;
}

export const Drawer = (props: Props) => {
    const classes = useStyles({});
    const { isOpen, header, onClose, children, id } = props;

    const rootClass = classnames({
        [classes.floatRight]: true,
        [classes.drawerClosed]: !props.isOpen,
    });

    const drawerClass = classnames({
        [classes.drawer]: true,
        [classes.drawerClosed]: !isOpen,
    });

    const drawerPaper = classnames({
        [classes.drawerPaper]: true,
        [classes.drawerClosed]: !isOpen,
    });

    return (
        <div className={rootClass}>
            <MuiDrawer
                id={id}
                open={isOpen}
                variant="permanent"
                anchor="right"
                elevation={10}
                className={drawerClass}
                classes={{
                    paper: drawerPaper,
                }}
                PaperProps={
                    {
                        //elevation: 10,
                    }
                }
            >
                <AppBar className={classes.appBar} position="relative" color="inherit">
                    <Toolbar className={classes.toolbar}>
                        {typeof header === "string" && (
                            <Text variant="h1" color="primary">
                                {header}
                            </Text>
                        )}
                        {typeof header !== "string" && header}
                        <PageActionButton onClick={onClose} color="primary">
                            <TimesIcon />
                        </PageActionButton>
                    </Toolbar>
                </AppBar>
                <div className={classes.content}>{children}</div>
            </MuiDrawer>
        </div>
    );
};
